export default __webpack_public_path__ + "static/media/custom-inactive.7a0eb152.svg";